import getLanguageByPath from '@src/utils/locale/getLanguageByPath.js';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName.js';

const languageFilePath = getLanguageByPath() === 'zh-cn' ? '' : `${getLanguageFolderName()}/`;

/**
 * @name pageLocalesData
 */
const pageLocalesData = {
  topBar: {
    navList: [{ name: '首页' }, { name: '世界观' }, { name: '编年史' }]
  },
  copyrightInformation: '版权信息',
  commText: '无法获取信息',
  modalText1: '关联势力',
  modalText2: '关联人物',
  // main 页面
  wordView: {
    header_text: `史称<span class="textColor">“大灾难”</span>的全球地质灾害为星球刻下难以磨灭的伤痕。
高山崩落、地面坍塌，岛屿沉没，火山升起，地磁几近消失，地图沦为废纸，
尘埃遮蔽天空，生态系统与人类社会均遭重创。
当灾难逐渐平息，幸存者们离开掩体重建家园，却发现灾害带来的<span class="textColor">特异碳硅矿物“EIC”</span>已经改变了地球生态，
被EIC高度侵蚀的污染地带<span class="textColor">“褪色区”</span>在世界范围内不断扩张。
曾预警了“大灾难”的地质学研究机构指出，观测数据显示快速扩张的褪色区将在三十年内吞没每一片陆地，
如何应对EIC带来的威胁，已成为当下人类社会最重要的议题。`,
    part1_title: 'EIC',
    part1_text:
      '性质极为特殊的碳硅矿物，学名为“芯石”。EIC是“喷发性无机碳化物”（Eruptive Inorganic Carbide）的首字母缩写，但取决于各方的不同认知，也被诠释为“喷出型等轴碳化硅”、“地方性侵入灾害”、“知觉信息导体”、“散发性无尽恩赐”等不同短语。EIC诞生于新纪元年的全球地质灾害，随火山活动形成高耸的矿柱和危险的矿区。这种谜团缠身的矿物潜藏着无可比拟的技术价值，已在能源工业和电子工业中得到广泛应用，成为灾后重建的重要支柱；但与此同时，EIC也危害着幸存者的身体健康和生命安全，急遽扩张的芯石污染大肆侵吞人类的生存空间，已是文明的头号威胁。',
    part2_title: '褪色灾害',
    part2_text: `火山活动和芯石崩解将大量EIC尘屑释入大气，催生了无孔不入的芯石污染。高浓度EIC令动植物在褪色病中衰弱死去、它们的亡骸结晶矿化，甚至整片地区、整座城市都可能被高纯度次生芯石结晶覆盖吞没，转化为纯粹且死寂的“褪色区”。
现如今，褪色区正伴随着致命的芯石脉冲暴快速扩张，人类却依然对EIC知之甚少。它是单纯的天灾，还是某种更加超乎想象的存在？面对未知的威胁，各大阵营给出了截然不同的应对方案——或对抗、或适应、或逃亡。孰是孰非？答案依然无人知晓。`,
    part3_title: '灾后新世界',
    part3_title1: '大灾难',
    part3_text1:
      '由甚大日冕物质抛射引发的全球地质灾害。高能带电粒子流轰击地磁层、扰乱外地核自转，令地磁几近消失、核幔物质交换反常加速。高度活跃的的热地幔柱冲击地壳，引发超大规模地震和火山活动，EIC随之喷薄而出，世界天变地异。',
    part3_title2: '新版图',
    part3_text2:
      '大灾难永久改变了全球地貌。高山崩落、地表塌陷，岛屿沉没、火山升起，地磁几近消失、地图沦为废纸，尘埃遮蔽天空，生态系统与人类社会均遭重创，幸而掩体城市群与月球定居点成功保存了火种，文明得以延续。',
    part3_title3: '新格局',
    part3_text3:
      '幸存者们不仅要重建满目疮痍的家园、还须提防前所未见的芯石威胁、应对褪色危机，区域合作逐渐成为主旋律，全球形成沃图里亚战略同盟、希古尼亚联合体、环塔拉萨洋联邦三大阵营鼎立的局面。月球都市也在大灾难的混乱中独立为月海共同体，成为灾后文明的第四极。',
    part3_title4: '新热点',
    part3_text4:
      '无论为了科学研究还是商业利益，EIC都是不可或缺的“命脉”。人们畏惧“褪色区”，却又深入其中开采芯石，围绕着EIC发生无数摩擦与冲突。现时，各路人马云集于最大的褪色区——玛什马克群岛周边，酝酿着又一场暴风雨。',
    part4_title: '机兵时代',
    part4_text: `大灾难后，全球交通网络支离破碎、难以修复，传统车辆失去用武之地，月球人发明的步行机械一举占据主流地位。步行载具为适应月面的崎岖地形而生，能够轻松跨越土石沟壑等阻碍出现在传统载具的“禁区”，为受困的幸存者们带来物资和希望。
然而，在步行机商队跨越破碎地形重连复兴之路的同时，披坚执锐的机兵也点燃了纷争之火。这些“能从任何地方出现”的装甲单位轻易取代了寸步难行的传统载具，在配给战争、南部战争、边境战争等多次冲突中证明了自己的价值。于边境战争中一战成名的三代机兵更是脱胎换骨，为机兵奠定了“陆战之王”的地位。`,
    part5_title: '解限机兵',
    part5_text:
      '三代机兵是“意识投影型机兵”的同义词。所谓“意识投影”，是利用一台EIC超级电脑“C脑”中继，在人脑与拟人机体间建立映射的脑机技术。意识投影系统接入人脑直接参与机体演算，满足EIC传感器、流体装甲、反耦合近战兵器等新型武装的算力需求，令机体获得远超其他载具的强大战力。解限型机兵在此基础上更进一步，允许参考驾驶员的生理指标逐步解除人机同步限制，令机体爆发数倍于常态的性能。然而，性能增幅似乎只是解限系统的附带功能，而非其设计目的……',
    part6_title: 'S.H.A.D.O.W.行动队',
    part6_text:
      'S.H.A.D.O.W.行动队是大型民间组织“边境路网”旗下的武装团体。这支精锐部队游离于各大阵营之外却得到多方支持，驾驶解限型机兵协助全球幸存者们解决由EIC引发的冲突与压迫，探寻EIC谜团重重的本质——面对即将吞没全球褪色灾害，是否存在对抗、适应或逃亡之外的道路？一条由芯石“引导”，又由解限系统揭示的全新道路。',
    part7_title: '纷争',
    part7_text:
      '探寻真相之路崎岖坎坷。S.H.A.D.O.W.行动队不仅时常直面EIC的威胁，亦被迫对抗人类的恶意。即使解限型机兵并非单纯的“兵器”，也必须为不可避免的冲突做好准备。谨记，武力无法实现我们的目的，却是实现目的的必要手段。'
  }
};

export default mergeLocalesData(pageLocalesData);
